/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ListingStrategy = {
    strategyMode?: ListingStrategy.strategyMode;
};
export namespace ListingStrategy {
    export enum strategyMode {
        MORE_OTA = 'more-ota',
        STATIC_SLOT = 'static-slot',
        OTA_FIRST = 'ota-first',
        MIX = 'mix',
        ONE_ALGORITHM = 'one-algorithm',
        ONE_ALGORITHM_TILING = 'one-algorithm-tiling',
        NEAR_GEO = 'near-geo',
        ABO_OTA_REGION = 'abo-ota-region',
        ABO_OTA_VOIVODESHIP = 'abo-ota-voivodeship',
        ABO_OTA_CITY = 'abo-ota-city',
        ABO_OTA_COUNTRY = 'abo-ota-country',
    }
}
